"use client";
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import SocialMedia from "../SocialMedia/SocialMedia";
import { Link } from "react-router-dom";
import logo from "../../Assets/logo-white.png";
import "./Footer.scss";
import { Image } from "react-bootstrap";


const Footer = () => {
  

  return (
    <Container fluid className="footer">
      <Container>
        <Row className="alignEnd">
          <Col md={6} sm={6} xs={12} lg={6} className="footer-section">
            <div className="footer-logo">
              
              <Image
                width={100}
                height={100}
                src={logo}
                className="img-fluid logo"
                alt="Klean Leaf logo"
              /> 
              
              <div className="footer-brand">Klean Leaf</div>
            </div>
            <p className="footer-subtitle">Laundry Detergent Sheets Manufacturer</p>
          </Col>
          <Col md={2} sm={2} xs={6} lg={2} className="footer-section">
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/about">About</Link>
              </li>
              <li>
                <Link to="/products">Products</Link>
              </li>
            </ul>
          </Col>
          <Col md={2} sm={2} xs={2} lg={2} className="footer-section">
            <ul>
              <li>
                <Link to="/production">Production</Link>
              </li>
              <li>
                <Link to="/solution">Solution</Link>
              </li>
            </ul>
          </Col>

          <Col md={2} sm={2} xs={2} lg={2} className="footer-section">
            <ul>
              <li>
                <Link to="/blogs">Blogs</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </Col>

        </Row>
        <Row>
          <Col className="text-center">
            {/* Add your footer note here */}
          </Col>
        </Row>

        <Row>
          <Col md={3} sm={6} xs={12} lg={6} className="footer-copywright">
          <a href="/" className="design white" style={{ textDecoration: "none" }}><p>Designed by Klean Leaf</p></a>
          </Col>
          <Col md={3} sm={6} xs={12} lg={3} className="footer-copywright">
            <a
              href="mailto:hello@kleanleaf.us"
              style={{ textDecoration: "none" }}
              target="_blank"
              className="white"
              rel="noopener noreferrer"
            >
              <p>hello@kleanleaf.us</p>
            </a>
          </Col>
          
          <Col md={3} sm={6} xs={12} lg={3} className="footer-body left">
            <SocialMedia />
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default Footer;
